export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const SET_OTP_NOTIFICATION = 'SET_NOTIFICATION';
export const REMOVE_OTP_NOTIFICATION = 'REMOVE_NOTIFICATION';
